// Solo lo que hace falta de un CollectionLog: un import de tipos rompe el babel de los tests.
type ChangesLog = {
  metadata?: { changes?: Record<string, { from: unknown; to: unknown }> } | null;
};

// La hora de un valor RFC3339 tal como lo mandó el cliente ("2026-11-04T14:00:00-03:00" → "14:00").
const wallClock = (value: unknown) =>
  typeof value === 'string' && value.length >= 16 ? value.slice(11, 16) : '-';

const shown = (value: unknown) =>
  value === null || value === undefined || value === '' ? '-' : String(value);

// Lo que cambió el cliente al editar su colecta, para la línea de tiempo.
export const collectionChangesText = (log: ChangesLog): string => {
  const changes = log.metadata?.changes ?? {};
  const parts: string[] = [];
  const {
    scheduledStart,
    scheduledEnd,
    declaredQuantity,
    declaredDescription,
    notes,
  } = changes;
  if (scheduledStart)
    parts.push(
      `Inicio de la franja: ${wallClock(scheduledStart.from)} → ${wallClock(scheduledStart.to)}`,
    );
  if (scheduledEnd)
    parts.push(
      `Fin de la franja: ${wallClock(scheduledEnd.from)} → ${wallClock(scheduledEnd.to)}`,
    );
  if (declaredQuantity)
    parts.push(
      `Cantidad: ${shown(declaredQuantity.from)} → ${shown(declaredQuantity.to)}`,
    );
  if (declaredDescription)
    parts.push(
      `Qué entrega: ${shown(declaredDescription.from)} → ${shown(declaredDescription.to)}`,
    );
  if (notes) parts.push('Cambió las observaciones');
  return parts.join(' · ');
};
